import { render, staticRenderFns } from "./CreateNewDefaultFolderModal.vue?vue&type=template&id=3e969ac0&"
import script from "./CreateNewDefaultFolderModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewDefaultFolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports